import { Component } from '@angular/core';
import { selectIsLoggedIn } from '../../shared/auth/auth.selectors';
import { Store } from '@ngrx/store';
import { AppState } from '../../app.reducer';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { SecureLayoutComponent } from '../secure/secure-layout/secure-layout.component';
import { PublicLayoutComponent } from '../public/public-layout/public-layout.component';
import { LoadingIndicatorComponent } from 'src/app/shared/loading-indicator/loading-indicator.component';

@Component({
  selector: 'app-root-layout',
  templateUrl: './root-layout.component.html',
  styleUrls: ['./root-layout.component.scss'],
  standalone: true,
  imports: [
    CommonModule,
    RouterModule,
    SecureLayoutComponent,
    PublicLayoutComponent,
    LoadingIndicatorComponent
  ]
})
export class RootLayoutComponent {
  selectIsLoggedIn$ = this.store.select(selectIsLoggedIn)

  constructor(private store: Store<AppState>) {
  }
}
